function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { useTestId } from '@wolffun/testable-id';
import useActiveTab from '@wolffun/shared/src/hooks/useActiveTab';

const Categories = ({
  selectedKey,
  data,
  className,
  onClickItem
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  const {
    lineRef,
    refs
  } = useActiveTab({
    selectedKey,
    data,
    onFilter: item => item.key === selectedKey
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, data.map((e, index) => /*#__PURE__*/React.createElement("div", _extends({
    onClick: () => onClickItem(e),
    className: classNames(styles.item, selectedKey === e.key && styles.active),
    key: e.key,
    ref: ref => {
      if (ref) {
        refs.current[index] = ref;
      }
    }
  }, generateTestIdProps('tabs', e.dataTestId)), /*#__PURE__*/React.createElement("span", {
    className: styles.spanName
  }, e.name))), /*#__PURE__*/React.createElement("div", {
    className: styles.line,
    ref: lineRef
  }));
};

export default Categories;